import React from 'react';
import {ITextStyles, TextCompat as Text} from 'components/FluentUICompat';
import {useKeywordsTranslations} from '../keywords.commonHooks';

interface Props {
	children: React.ReactElement;
	list: unknown[];
}

const textStyles: ITextStyles = {
	root: {
		display: 'block',
		marginTop: 0,
		marginBottom: '0.8rem',
	},
};

export function FieldWrapper({
	children,
	list,
}: Props): React.ReactElement | null {
	const {t} = useKeywordsTranslations();

	if (list.length) return children;
	return (
		<Text as='p' styles={textStyles}>
			{t('EmptyField')}
		</Text>
	);
}
